export default "__VITE_ASSET__xrMeSJJ1__"